"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactFlatpickr = _interopRequireDefault(require("react-flatpickr"));

var _flatpickr = _interopRequireDefault(require("flatpickr"));

var _l10n = _interopRequireDefault(require("flatpickr/dist/l10n"));

var _overrides = require("../../../utils/overrides");

var _Input = _interopRequireDefault(require("../Input"));

var _Icon = _interopRequireDefault(require("../../general/Icon"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'DatePicker'); // Safari fix

(function () {
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (!isSafari) return;
  if (document.getElementById('flatpickr')) return;
  var styleTag = document.createElement('style');
  styleTag.id = 'flatpickr';
  var headTag = document.getElementsByTagName('head')[0];
  headTag.insertBefore(styleTag, headTag.childNodes[0]);
})();

function DatePicker(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      name = _ref.name,
      dateFormat = _ref.dateFormat,
      formatDate = _ref.formatDate,
      onChange = _ref.onChange,
      value = _ref.value,
      type = _ref.type,
      outputType = _ref.outputType,
      lang = _ref.lang,
      isReadOnly = _ref.isReadOnly,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "name", "dateFormat", "formatDate", "onChange", "value", "type", "outputType", "lang", "isReadOnly"]);
  var flatpickrRef = (0, _react.useRef)();
  var open = (0, _react.useRef)(false);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, DatePicker.overrides); // Classes

  var rootClassName = (0, _classnames.default)(classes.root, classNameProp);
  var flatpickrOptions = (0, _react.useMemo)(function () {
    var defaultDateFormats = {
      date: 'Y-m-d',
      datetime: 'Y-m-d H:i:S',
      time: 'H:i'
    };
    return (0, _extends2.default)({
      enableTime: type !== 'date',
      noCalendar: type === 'time',
      dateFormat: dateFormat || defaultDateFormats[type],
      formatDate: formatDate,
      locale: _l10n.default[lang],
      clickOpens: !isReadOnly,
      time_24hr: true,
      disableMobile: true
    }, override.flatpickrOptions);
  }, [dateFormat, formatDate, isReadOnly, lang, override.flatpickrOptions, type]);
  var onReady = (0, _react.useCallback)(function (_, __, fp) {
    fp.calendarContainer.classList.add(classes.container);
  }, [classes.container]);
  var onChangeDate = (0, _react.useCallback)(function (date) {
    var formattedDate = outputType === 'string' ? _flatpickr.default.formatDate(date[0], flatpickrOptions.dateFormat) : date[0];
    onChange && onChange(formattedDate, name);
  }, [flatpickrOptions.dateFormat, name, onChange, outputType]); // Remove handler

  var onInputChange = (0, _react.useCallback)(function () {
    onChange && onChange(undefined, name);
  }, [name, onChange]);
  var onClick = (0, _react.useCallback)(function (e) {
    e.stopPropagation();
    open.current && flatpickrRef.current.flatpickr.input.focus();
  }, []);
  var onMouseDown = (0, _react.useCallback)(function (e) {
    open.current = !flatpickrRef.current.flatpickr.isOpen;
  }, []);
  var flatpickrRender = (0, _react.useCallback)(function (_ref2, ref) {
    var className = _ref2.className,
        value = _ref2.value;
    var formatValue = value && outputType === 'object' ? formatDate ? formatDate(value, flatpickrOptions.dateFormat) : _flatpickr.default.formatDate(value, flatpickrOptions.dateFormat) : value;
    var inputClasses = value && !isReadOnly ? {
      postCloseComponent: classes.clear
    } : null;
    return /*#__PURE__*/_react.default.createElement(_Input.default, (0, _extends2.default)({}, props, {
      value: formatValue,
      className: className,
      isReadOnly: isReadOnly,
      onChange: isReadOnly ? undefined : onInputChange,
      classes: inputClasses,
      overrides: {
        input: {
          ref: ref
        }
      },
      postComponent: /*#__PURE__*/_react.default.createElement("div", {
        onClick: onClick,
        onMouseDown: onMouseDown
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: type === 'time' ? classes.clockIcon : classes.calendarIcon,
        name: type === 'time' ? 'clock' : 'calendar'
      }))
    }));
  }, [classes.calendarIcon, classes.clear, classes.clockIcon, flatpickrOptions.dateFormat, formatDate, isReadOnly, onClick, onInputChange, onMouseDown, outputType, props, type]);
  var key = "flatpickr-".concat(name || 'anon', "--").concat(isReadOnly ? 'read-only' : 'active');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement(_reactFlatpickr.default, (0, _extends2.default)({
    ref: flatpickrRef,
    key: key,
    options: flatpickrOptions,
    render: flatpickrRender,
    overrides: overridesProp,
    value: value,
    onReady: onReady,
    onChange: isReadOnly ? undefined : onChangeDate
  }, override.flatpickr)));
}

DatePicker.overrides = ['root', 'input', 'error', 'info', 'formControl', 'Label', 'flatpickr', 'flatpickrOptions'];
DatePicker.defaultProps = {
  labelMode: 'horizontal',
  type: 'date',
  outputType: 'object',
  onChange: function onChange() {},
  value: '',
  dateFormat: '',
  lang: 'en',
  isReadOnly: false,
  override: {}
};
process.env.NODE_ENV !== "production" ? DatePicker.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onEnter: _propTypes.default.func,

  /** Native input id */
  id: _propTypes.default.string,

  /** Native input name */
  name: _propTypes.default.string,
  value: _propTypes.default.any,
  label: _propTypes.default.string,
  labelMode: _propTypes.default.oneOf(['horizontal', 'vertical']),
  isFullWidth: _propTypes.default.bool,

  /** Info popover */
  hint: _propTypes.default.string,

  /** Error will be displayed below the component with style changes */
  error: _propTypes.default.string,

  /** Info will be displayed below the component with style changes */
  info: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  isReadOnly: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['date', 'datetime', 'time']),
  outputType: _propTypes.default.oneOf(['object', 'string']),
  lang: _propTypes.default.string,

  /** default to flatpickr format tokens */
  dateFormat: _propTypes.default.string,

  /** Custom formatDate function */
  formatDate: _propTypes.default.func
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(DatePicker);

exports.default = _default;